export class TemporaryFile {
  constructor(props = {}) {
    this.id = props.id
    this.contents = props.contents || ''
    this.mime = props.mime || ''
  }

  export() {
    return {
      contents: this.contents,
      mime: this.mime
    }
  }
}
